export enum DiscountTypes {
  Prime = 'Prime',
  RappiCard = 'RappiCard',
  Normal = 'Normal'
}

export const DiscountTypeIcon = {
  [DiscountTypes.Prime]: 'icon-prime',
  [DiscountTypes.RappiCard]: 'icon-rappi-moustache',
  [DiscountTypes.Normal]: '',
};

export const DiscountTypeClass = {
  [DiscountTypes.Prime]: 'prime',
  [DiscountTypes.RappiCard]: 'rappicard',
  [DiscountTypes.Normal]: '',
};
